<template>
	<edit-layout
		@save="handleSave()"
		@cancel="$emit('browsMode')"
		class="certificate-form"
	>
		<div class="tips">
			*此為顯示於輔導員與學生挑戰完成證書之姓名，請再三確認，送出後不可修改，若有需要重印證書，則需請學校/輔導員負擔所延伸之相關費用。
			<br />建議使用威妥瑪 (WG) 拼音 --
			<a
				href="https://www.boca.gov.tw/sp-natr-singleform-1.html"
				target="_blank"
				class="color-blue1"
				>外交部外文姓名中譯英系統查詢</a
			>
		</div>
		<p style="color: red">
			羅馬拼音撰寫範例：王小明 WANG,HSIAO-MING （姓,名-名）
		</p>
		<br />
		<div class="layout-row">
			<div class="imformation layout-column">
				<el-form :model="$data" label-position="left" label-width="85px">
					<div class="team-member">
						<div class="title" v-if="!is18">超級英雄姓名拼音</div>
						<div class="title" v-else>夥伴姓名拼音</div>
						<div class="content">
							<div class="member" v-for="(member, i) in team_members" :key="i">
								<el-form-item :label="member.name" required>
									<div class="col" gutter="20">
										<el-form-item
											:prop="`team_members[${i}].wade_giles`"
											:rules="{ validator, trigger: 'blur' }"
										>
											<el-input
												v-model="member.wade_giles"
												@input="
													member.wade_giles = member.wade_giles.toUpperCase()
												"
												placeholder="姓名羅馬拼音"
											></el-input>
										</el-form-item>
										<el-form-item
											:prop="`team_members[${i}].department_zh`"
											:rules="{ validator: zhValidator, trigger: 'blur' }"
										>
											{{ team_members[i].department_zh }}&nbsp;&nbsp;
											<el-button
												@click="handleOpenSelectModal(team_members[i], i)"
												size="mini"
												type="primary"
												plain
												>選擇學校</el-button
											>
											<div v-if="team_members[i].showSchoolError" style="display:flex;justify-content: center;align-items: center; margin-left: 5px;"><div class="info">!</div><span style="color: red; margin-left: 5px;">尚未選擇學校</span></div>
										</el-form-item>
										<el-form-item
											:prop="`team_members[${i}].department_en`"
											:rules="{ validator: enValidator, trigger: 'blur' }"
										>
											<el-input
												v-model="member.department_en"
												placeholder="所屬單位(英文)"
												@input="
													member.department_en =
														member.department_en.toUpperCase()
												"
											></el-input>
										</el-form-item>
									</div>
								</el-form-item>
							</div>
						</div>
					</div>
					<div class="instructor">
						<div class="title" v-if="!is18">輔導員姓名拼音</div>
						<div class="title" v-else>代表人姓名拼音</div>
						<div class="content">
							<div class="member" v-for="(member, i) in counselors" :key="i">
								<el-form-item :label="member.name" required>
									<el-form-item
										:prop="`counselors[${i}].wade_giles`"
										required
										:rules="{ validator, trigger: 'blur' }"
									>
										<el-input
											v-model="member.wade_giles"
											@input="
												member.wade_giles = member.wade_giles.toUpperCase()
											"
											placeholder="姓名羅馬拼音"
										></el-input>
									</el-form-item>
									<el-form-item
										:prop="`counselors[${i}].department_zh`"
										:rules="{ validator: zhValidator, trigger: 'blur' }"
									>
										{{ counselors[i].department_zh }}&nbsp;&nbsp;
										<el-button
											@click="handleOpenSelectModal(counselors[i], i)"
											size="mini"
											type="primary"
											plain
											>選擇學校</el-button
										>
										<div v-if="counselors[i].showSchoolError" style="display:flex;justify-content: center;align-items: center; margin-left: 5px;"><div class="info">!</div><span style="color: red; margin-left: 5px;">尚未選擇學校</span></div>
									</el-form-item>
									<el-form-item
										:prop="`counselors[${i}].department_en`"
										:rules="{ validator: enValidator, trigger: 'blur' }"
									>
										<el-input
											v-model="member.department_en"
											placeholder="所屬單位(英文)"
											@input="
												member.department_en =
													member.department_en.toUpperCase()
											"
										></el-input>
									</el-form-item>
								</el-form-item>
							</div>
						</div>
					</div>
					<div>
						<div class="title">
							證書寄送地址 <br /><span style="color: red"
								>* 建議填寫貴校地址，較不易寄丟</span
							>
						</div>
						<div class="content">
							<el-form-item label="收件人" required>
								<el-input
									v-model="certificate_address.recipient"
									placeholder="收件人姓名"
								></el-input>
							</el-form-item>
							<el-form-item label="地址" required>
								<div class="col" gutter="5">
									<el-input
										v-model="certificate_address.zip"
										placeholder="郵遞區號"
									></el-input>
									<el-input
										v-model="certificate_address.city"
										placeholder="縣市"
									></el-input>
									<el-input
										v-model="certificate_address.address"
										placeholder="地址"
									></el-input>
								</div>
							</el-form-item>
							<el-form-item label="備註">
								<el-input
									v-model="certificate_address.note"
									placeholder="備註"
									type="textarea"
									:autosize="{ minRows: 2 }"
								></el-input>
							</el-form-item>
						</div>
					</div>
				</el-form>
			</div>
			<div class="example">
				<div class="title">國際證書範本</div>
				<img
					src="../../../../assets/award.jpg"
					style="width: 100%; max-width: 300px"
				/>
			</div>
		</div>
		<el-dialog :visible="dialogVisible" @close="handleClose()">
			<el-radio-group
				v-model="searchType"
				@change="
					getTeacherSchool(['searchCity', 'searchDistrict', 'searchSchool'])
				"
			>
				<el-radio :label="1">國小</el-radio>
				<el-radio :label="2">國中</el-radio>
				<el-radio :label="3">高中</el-radio>
				<el-radio :label="4">其他</el-radio>
			</el-radio-group>
			<br />
			<br />
			<div class="row" gutter="10">
				<el-select
					v-model="searchCity"
					placeholder="選擇縣市"
					@change="getTeacherSchool(['searchDistrict', 'searchSchool'])"
				>
					<el-option
						:label="city"
						:value="city"
						v-for="(city, i) in cityOptions"
						:key="i"
					/>
				</el-select>
				<el-select
					v-model="searchDistrict"
					placeholder="選擇區域"
					@change="getTeacherSchool(['searchSchool'])"
				>
					<el-option
						:label="district"
						:value="district"
						v-for="(district, i) in districtOptions"
						:key="i"
					/>
				</el-select>
			</div>
			<br />
			<el-select
				v-if="searchType != 4"
				v-model="searchSchool"
				placeholder="單位名稱"
				:loading="loading"
				@change="handleSelectSchool()"
			>
				<el-option
					:label="school.name"
					:value="school.name"
					v-for="(school, i) in schoolList"
					:key="i"
					>{{ school.name }}</el-option
				>
			</el-select>
			<el-input v-else v-model="searchSchool" placeholder="單位名稱">
				<el-button slot="append" @click="handleSelectSchool()">確定</el-button>
			</el-input>
		</el-dialog>
	</edit-layout>
</template>

<script>
import _ from "lodash";
import { mapActions, mapMutations, mapState } from "vuex";
import EditLayout from "./EditLayout.vue";
var cityJson = require("@/data/city.json");

export default {
	props: ["is18"],
	data() {
		return {
			loading: false,
			dialogVisible: false,
			team_members: [],
			counselors: [],
			certificate_address: {
				recipient: "",
				address: "",
			},
			searchType: 1,
			searchCity: "基隆市",
			searchDistrict: "",
			searchSchool: "",
			schoolList: [],
			selectInstance: null,
		};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		cityOptions() {
			return Object.keys(cityJson);
		},
		districtOptions() {
			return cityJson[this.searchCity] || [];
		},
	},
	methods: {
		...mapMutations("story", ["updateEditStoryData"]),
		...mapActions("story", ["updateStory", "checkProgress"]),
		...mapActions("user", ["getSchool"]),
		init() {
			this.team_members = this.editStoryData.team_members || [];
			this.counselors = this.editStoryData.counselors || [];
			this.certificate_address = this.editStoryData.certificate_address || {};
		},
		validator(rule, value, callback) {
			if (!value) callback(new Error("必填"));
			else if (!/^[A-Z][A-Z ]*,([A-Z]*-?){1,2}$/.test(value)) {
				callback(new Error("例：WANG,HSIAO-MING（姓,名-名）"));
			} else callback();
		},
		enValidator(rule, value, callback) {
			if (!value) callback(new Error("必填"));
			else if (!/^[a-zA-Z\s]+$/.test(value)) {
				callback(new Error("請填寫英文"));
			} else callback();
		},
		zhValidator(rule, value, callback) {
			if (!value) callback(new Error("必填"));
			else if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
				callback(new Error("請填寫中文"));
			} else callback();
		},
		async handleSave() {
			// Reset all error flags first
			this.team_members.forEach(member => {
				this.$set(member, 'showSchoolError', false);
			});
			this.counselors.forEach(member => {
				this.$set(member, 'showSchoolError', false);
			});
			
			// Check if schools are selected
			let hasError = false;
			this.team_members.forEach((member, i) => {
				if (!member.department_zh) {
					this.$set(member, 'showSchoolError', true);
					hasError = true;
				}
				_.assign(this.editStoryData.team_members[i], member);
			}, this);
			
			this.counselors.forEach((member, i) => {
				if (!member.department_zh) {
					this.$set(member, 'showSchoolError', true);
					hasError = true;
				}
				_.assign(this.editStoryData.counselors[i], member);
			}, this);
			
			// If there are errors, don't proceed with saving
			if (hasError) {
				return;
			}
			
			this.editStoryData.certificate_address = _.assign(
				this.editStoryData.certificate_address,
				this.certificate_address
			);
			let data = _.pick(_.cloneDeep(this.editStoryData), [
				"id",
				"team_members",
				"counselors",
				"certificate_address",
			]);
			this.updateEditStoryData(data);
			data.progress = await this.checkProgress();
			await this.updateStory(data);
			this.$emit("browsMode");
			this.$message.success("儲存成功");
		},
		async getTeacherSchool(searchKeys = new Array()) {
			searchKeys.forEach((key) => (this[key] = ""));
			if (this.searchType && this.searchCity && this.searchDistrict) {
				this.loading = true;
				this.schoolList = await this.getSchool({
					category: this.searchType,
					city: this.searchCity,
					district: this.searchDistrict,
				});
				this.loading = false;
			}
		},
		handleOpenSelectModal(instance, i) {
			this.searchType = 1;
			this.searchCity = "";
			this.searchDistrict = "";
			this.searchSchool = "";
			this.dialogVisible = true;
			this.selectInstance = instance;
		},
		handleSelectSchool() {
			const { searchSchool } = _.cloneDeep(this.$data);
			this.$set(this.selectInstance, "department_zh", searchSchool);
			// Clear the error flag when a school is selected
			if (searchSchool) {
				this.$set(this.selectInstance, "showSchoolError", false);
			}
			console.log(this.selectInstance);
			this.selectInstance = null;
			this.handleClose();
		},
		handleClose() {
			if (this.dialogVisible) this.dialogVisible = false;
		},
	},
	created() {
		this.init();
	},
	mounted() {},
	components: {
		EditLayout,
	},
};
</script>

<style lang="scss" scoped>
:deep(.el-form-item__content){
	.el-form-item__content{
		display: flex;
	}
}
.certificate-form {
	.tips {
		margin-bottom: 31px;
	}

	.title {
		margin-bottom: 15px;
	}

	.imformation {
		width: 350px;
		margin-right: 40px;

		.team-member {
			margin-bottom: 10px;
		}

		.member {
			margin-bottom: 15px;
		}

		.content {
			padding-left: 20px;

			.name {
				width: 50px;
				margin-right: 20px;
			}
		}
	}
	.info{
		width: 15px;
		height: 15px;
		border-radius: 50%;
		font-size: 12px;
		font-weight: 500;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: red;
		color: #fff;
	}
}
</style>
